import React from 'react';
import './separationTitle.css';

export default function SeparationTitle ({label = '', description = '', display = true}) {
    if (!display) {
        return null
    }

    return (
        <div>
            <h3 className='neo-separation-title'>{label}</h3>
            {description && <p className='neo-separation-description'>{description}</p>}
            <div className='neo-separation-title-divider'/>
        </div>
    )
}

